import { headlineTicker } from '@/mocks/gossipEvents';

export default function BreakingTicker() {
  const loopItems = [...headlineTicker, ...headlineTicker];

  return (
    <div className="w-full bg-foreground-950 text-background-50">
      <div className="w-full px-4 md:px-6 h-10 flex items-center gap-3">
        <span className="shrink-0 inline-flex items-center gap-1.5 rounded-full bg-primary-500 px-3 py-1 text-xs font-semibold font-label text-background-50 dark:text-foreground-950">
          <i className="ri-flashlight-fill animate-pulse-soft"></i>
          速报
        </span>
        <div className="relative flex-1 overflow-hidden">
          <div className="animate-marquee flex w-max items-center gap-10">
            {loopItems.map((text, index) => (
              <span key={`${text}-${index}`} className="text-xs md:text-sm text-background-200 whitespace-nowrap">
                <span className="text-accent-400 mr-2">●</span>
                {text}
              </span>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}